module.exports = __webpack_public_path__ + "static/media/HiraginoSansGBW3.6fa1c5ed.svg";